document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('modal-opener').forEach((opener) => {
    opener.addEventListener('click', function () {
      const modalSelector = opener.getAttribute('data-modal');
      const modal = document.querySelector(modalSelector);

      if (modal && modal.show) {
        modal.openedBy = opener;
        modal.show(opener);
      }
    });
  });
});
